module.exports = __webpack_public_path__ + "flyer_background_chalk_016-4042c3d2771989f799155ab6350f64a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_chalk_016.jpg
// module id = 1617
// module chunks = 1